import React, { Suspense, lazy } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { 
  //BrowserRouter as Router, 
  Routes,
  Route, 
  useLocation,
} from 'react-router-dom';

import Header from './components/Header';
import SideBar from './components/Sidebar';
import TaskYearsCyclesStructure from './components/TaskList';
import FormList from './components/FormList';
//import Task from './components/Task';
import FormPage from './components/FormRenderer/FormPage';
import FormBuilder from './components/FormBuilder/FormBuilder';
import FormCreate from './components/FormCreate';
import TasksLoad from './components/TasksLoad';
import TaskCreate from './components/TaskCreate';

//import ExportGrid from './components/ExportDataGrid';

//import axios from 'axios';
import axios_api from './Api';
import { API_URL, AUTH_TOKEN } from './Context';
import FormEditParams from './components/FormEditParams';


function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
}


// JS code splitting
const DataGrid = lazy(() => import('./components/ExportDataGrid'));


function ProtectedPages({setAuthToken, appUserName, setAppUserName}) {
  //const [taskYearsCycles, setTaskYearsCycles] = useState([]);
  //const api_url = useContext(API_URL);  
  //const token = useContext(AUTH_TOKEN);

  
  return(
    <>
      <ScrollToTop />
      <Header 
        setAuthToken={setAuthToken} 
        appUserName={appUserName} 
        setAppUserName={setAppUserName}
      /> 
      <div className="row plato">
        <div className="col-2 fixed-top vh-100 p-0 left-panel-wrapper">
          <SideBar
          />
        </div>
        <div className="col-2"></div>
        <div className="col-10 border-start px-4 pb-4 right-panel">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route exact path="/" element={
                <TaskYearsCyclesStructure/>
              }/>
              <Route exact path="/form_list" element={
                <FormList/>
              }/>
              <Route exact path="/form_create" element={
                <FormCreate/>
              }/>
              <Route exact path="/load_tasks" element={
                <TasksLoad/>
              }/>                
              <Route exact path="/task_create" element={
                <TaskCreate/>
              }/>                          
              <Route path="/form_builder/:formId" element={
                <FormBuilder/>
              }/>              
              <Route path="/task/:taskId" element={
                <FormPage
                  formMode="specialist"
                  taskUrl="/manage_task/"
                />
              }/>
              <Route path="/export/:taskId" element={
                <DataGrid/>
              }/>       
            </Routes>
          </Suspense>  
        </div>
      </div>
    </>
  )
}

export default ProtectedPages